import { Controller } from "stimulus"

export default class extends Controller {
  initialize() {
    this.nav_content = $(".js-main-side-nav__content");
    this.nav_bg = $(".js-main-side-nav__bg");
    this.nav = $(".js-main-side-nav");
    this.body = $(".js-body");
    this.clicked_search = false;

    this.toggle_freeze_scroll = (freeze, element) => {
      if (freeze) {
        element.css({ "max-height": "100vh", overflow: "hidden" });
      } else {
        element.css({ "max-height": "", overflow: "" });
      }
    };

    this.collapse_main_side_nav = (nav, nav_bg, nav_content, body) => {
      nav.addClass("visibility-hidden");
      nav_bg.removeClass("anim-visible").addClass("anim-hidden");
      nav_content.removeClass("anim-appear-from-left");
      this.toggle_freeze_scroll(false, body);
    };

    // Add path check and auto-toggle
    if (window.location.pathname === '/money-101') {
      this.toggleSearch();
    }
  }

  expandSideNav() {
    this.nav.removeClass("visibility-hidden");
    this.nav_bg.removeClass("anim-hidden").addClass("anim-visible");
    this.nav_content
      .removeClass("anim-disappear-to-right")
      .addClass("anim-appear-from-left");
    this.toggle_freeze_scroll(true, this.body);
    this.activateDialog();
  }

  collapseSideNav() {
    this.deactivateDialog();
    this.collapse_main_side_nav(
      this.nav,
      this.nav_bg,
      this.nav_content,
      this.body
    );
    this.nav_content.addClass("anim-disappear-to-right");
    setTimeout(() => {
      this.nav_content.removeClass("anim-disappear-to-right");
    }, 400);
  }

  activateDialog() {
    this.previouslyFocused = document.activeElement;
    this.boundTrapFocus = (event) => this.trapFocus(event);
    document.addEventListener("keydown", this.boundTrapFocus);
    const closeButton = this.nav_content.find(".main-side-nav__close")[0];
    if (closeButton) closeButton.focus();
  }

  deactivateDialog() {
    document.removeEventListener("keydown", this.boundTrapFocus);
    if (this.previouslyFocused && this.previouslyFocused.focus) {
      this.previouslyFocused.focus();
    }
  }

  trapFocus(event) {
    if (event.key !== "Tab") return;
    if (this.nav.hasClass("visibility-hidden")) return;

    const focusable = this.dialogFocusable();
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  dialogFocusable() {
    return this.nav_content
      .find('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      .toArray()
      .filter((element) => element.offsetParent !== null);
  }

  toggleSearch() {
    $("#search-bar-header").toggle();
    $("#search-blog-posts-input").focus();
  }

  connect() {
    $("#search-blog-posts-input").on('keyup', (e) => {
      if (e.keyCode === 13) {
        this.clicked_search = false;
      }
    });

    $("#search-blog-posts-input").on("focus", () => {
      this.clicked_search = true;
    });

    // Add path change listener
    window.addEventListener('popstate', () => {
      if (window.location.pathname === '/money-101') {
        this.toggleSearch();
      }
    });
  }

  disconnect() {
    this.deactivateDialog();
    this.collapse_main_side_nav(
      this.nav,
      this.nav_bg,
      this.nav_content,
      this.body
    );
    $("#search-bar-header").hide();

    if (this.clicked_search) {
      let search_length = 0;
      let search_input = $("#search-blog-posts-input").val().length;

      if (search_input > 0 && search_input <= 10) {
        search_length = 10;
      } else if (search_input > 10) {
        search_length = 20;
      }
    }
  }
}
